export default {
  dessertList: document.querySelector('.dessert-list'),
  dessertCategory: document.querySelector('.dessert-category'),
  dessertLoadMoreBtn: document.querySelector('.dessert-load-more-btn'),
  dropdown: document.querySelector('.category-dropdown'),
  dropdownBtn: document.querySelector('.category-dropdown__btn'),
  dessertLoader: document.querySelector('.dessert-loader'),
};
